import { render } from "./AppFooter.vue?vue&type=template&id=71e3bd1e"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=71e3bd1e&lang=scss"
script.render = render

export default script